"use client"

import Login from '@/features/login/templates'
import { usePageMeta } from '@aw/lib'
import { Suspense } from 'react'



export default function Page() {
    usePageMeta({
        title: "Login | AbroadWorks",

    })
    return <Suspense><Login /></Suspense>
}



